/** @module csi/action/NewFileControllerForImages */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/NewFileController",
	"csi/comm/Aspera"
], function(declare,lang,NewFileController,Aspera){

	return declare(NewFileController, {
		preProcess: function () {
			if (Aspera.isEnabled()){
				this.disableActionView(true);
				this.closeDialog();
				Aspera.uploadFile(this.m_urlParent, "", false, false, this).then(
					(response) => {
						this._onPublishResponse(response)
					},
					(msg) => {
						// Do not show error if user cancels file selection
						this.m_error = msg || "";
						this.postProcess(false);
					}
				);
				return;
			}

			this.inherited(arguments);
		},

		getError: function (suffix, params) {
			return this.m_error ? this.m_error : this.inherited(arguments);
		},
	});
});